import { loginFormTranslationsEn } from '../../app/pages/authorization/LoginForm/translations';
import { usersPageTranslationsEn } from '../../app/pages/users/translations';
import { notFoundPageTranslationsEn } from '../../app/pages/notFoundPage/translations';
import { commonTranslationsEn } from './common/translations';
import { versionsPageTranslationsEn } from '../../app/pages/versions/translations';
import { tachoModalTranslationsEn } from '../../app/components/TachoModal/translations';
import { confirmationModalTranslationsEn } from '../../app/components/TachoConfirmationModal/translations';
import { licencesPageTranslationsEn } from '../../app/pages/licenses/translations';
import { tachoReleaseTypeEnumTranslationsEn } from '../domainModels/versions/TachoReleaseType';
import { clientsPageTranslationsEn } from '../../app/pages/clients/translations';
import { distributorsPageTranslationsEn } from '../../app/pages/distributors/translations';
import { licenseTermsPageTranslationsEn } from '../../app/pages/licenseTerms/translations';

export const english = {
    Key: 'en-GB',
    values: {
        ...notFoundPageTranslationsEn,
        ...commonTranslationsEn,
        ...loginFormTranslationsEn,
        ...usersPageTranslationsEn,
        ...versionsPageTranslationsEn,
        ...tachoModalTranslationsEn,
        ...confirmationModalTranslationsEn,
        ...licencesPageTranslationsEn,
        ...tachoReleaseTypeEnumTranslationsEn,
        ...clientsPageTranslationsEn,
        ...distributorsPageTranslationsEn,
        ...licenseTermsPageTranslationsEn,
    },
};
